import React from 'react'
import { useSelector } from 'react-redux'
import { translate } from '../languages'
import { RootState } from '../stores'

type NumberFormatProps = {
  value: number
  suffixKey: string
}

export const NumberFormat: React.FC<NumberFormatProps> = ({
  value,
  suffixKey,
}) => {
  const { language } = useSelector((state: RootState) => state.language)

  return (
    <span>
      {`${parseFloat(value.toFixed(3))
        .toString()
        .replace(
          /\B(?=(\d{3})+(?!\d))/g,
          suffixKey === 'common.moneyType' ? ' ' : ','
        )} (${translate(suffixKey, language)})`}
    </span>
  )
}
